<template>
  <div class="scrollable" style="max-width: 100%; min-width: 80%;">
    <VuePdfEmbed
      id="view-asset-dialog-pdfEmbed"
      :source="asset.url"
      annotation-layer text-layer
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import VuePdfEmbed from 'vue-pdf-embed';

export default defineComponent({
  name: 'EmbedPdfPreview',
  components: { VuePdfEmbed },
  props: {
    asset: {
      type: Object,
      required: true,
    }
  },
})
</script>
